import React, { useContext } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import PropTypes from "prop-types"
import { SchemaContext } from "../contexts/SchemaContext"
import { UserContext } from "../contexts/UserContext"
import DownloadFileButton from "./DownloadFileButton"
import RequestMegafileButton from "./RequestMegafileButton"
import QuarterlyDownloadFileButton from "./QuarterlyDownloadFileButton"

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  button: {
    minWidth: 300,
  },
}))

const ExportsOptionsCard = () => {
  const classes = useStyles()
  const { schema, schemaLoading, schemaError } = useContext(SchemaContext)
  const options = schema.filter((button) => button.button_type_id === 6)
  const quarterlyButtons = options.filter((option) => option.available_by_quarter)
  const downloadButtons = options.filter((option) => !option.available_by_quarter)
  const megafileButton = schema.find((option) => option.button_type_id === 7)
  console.log("megafileButton", megafileButton)
  const onSave = () => {
    console.log("megafile download")
  }
  const { user } = useContext(UserContext)
  const { accessLevel } = user
  const isAdmin = accessLevel === "ADMIN"
  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          Export Options
        </Typography>
        {schemaLoading && <p className="loading">loading ... </p>}
        {schemaError && <p className="error">{schemaError}</p>}
        <div
          style={{
            border: "1px solid",
            padding: "10px",
            borderRadius: "10px",
            marginBottom: "15px",
          }}
        >
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Complete Megafile
          </div>
          {isAdmin && megafileButton && (
            <CardActions style={{ textAlign: "Center", display: "block" }}>
              <RequestMegafileButton label={megafileButton.label} disabled={false} />
            </CardActions>
          )}
          {downloadButtons &&
            downloadButtons.map((option) => (
              <CardActions
                key={option.id}
                style={{ textAlign: "Center", display: "block" }}
              >
                <DownloadFileButton
                  label={option.label}
                  context={option.folder_name}
                  disabled={false}
                  saveActivity={onSave}
                  maxQuarters={option.max_quarters}
                />
              </CardActions>
            ))}
        </div>

        {quarterlyButtons &&
          quarterlyButtons.map((option) => (
            <CardActions key={option.id} style={{ padding: 0 }}>
              <div
                style={{
                  border: "1px solid",
                  padding: "10px",
                  borderRadius: "10px",
                  width: "100%",
                }}
              >
                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                  Client Template (Pivoted Megafile)
                </div>
                <QuarterlyDownloadFileButton
                  label={option.label}
                  disabled={false}
                  saveActivity={onSave}
                  maxQuarters={option.max_quarters}
                />
              </div>
            </CardActions>
          ))}
      </CardContent>
    </Card>
  )
}

ExportsOptionsCard.propTypes = {
  uploads: PropTypes.array,
  options: PropTypes.array,
  error: PropTypes.string,
  loading: PropTypes.bool,
}

export default ExportsOptionsCard
